var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      ref: "headerpart",
      staticClass: "header",
      class: [
        {
          "msg-fixed":
            _vm.betSlipState &&
            _vm.headerMessageState &&
            _vm.mobileBigAndBelow &&
            !_vm.isOpenedFromWebView,
          postLoginAlertExist: _vm.postLoginAlertExist && !_vm.mobileBigAndBelow
        },
        {
          withPageTitle:
            _vm.showPageTitleInHeader &&
            !_vm.isRootSportsNavigation &&
            _vm.mobileBigAndBelow &&
            !["pm", "racing"].includes(_vm.currentNavGroupKey)
        },
        _vm.brandKey
      ]
    },
    [
      _c("resize-observer", { on: { notify: _vm.headerResize } }),
      _vm._v(" "),
      !_vm.mobileBigAndBelow
        ? _c("headlinesLight", { attrs: { category: "PostLoginAlert" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.headerMessageState &&
      _vm.mobileBigAndBelow &&
      !_vm.isOpenedFromWebView &&
      (!_vm.isReadOnly || (_vm.isReadOnly && _vm.appInstallPopup))
        ? _c("header-messages")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticClass: "top-container",
          class: [
            {
              geo_search: _vm.mobileGeolocationInProgress.display,
              postLoginAlertExist:
                _vm.postLoginAlertExist && !_vm.mobileBigAndBelow
            }
          ],
          attrs: { "align-center": "" }
        },
        [
          !_vm.mobileBigAndBelow && _vm.brandLayout === "generic"
            ? _c("div", { staticClass: "rg" }, [
                _c("div", { staticClass: "rg-holder" }, [
                  _c("span", { staticClass: "header-txt" }, [
                    _vm._v(_vm._s(_vm.$t("Header.InfoMessageOne")))
                  ]),
                  _vm._v(" "),
                  _c("a", { attrs: { href: _vm.$t("RGLink." + _vm.state) } }, [
                    _c("img", {
                      staticClass: "rg-logo",
                      attrs: {
                        src: _vm.mediaServer(
                          "/static/brand-img/" + _vm.brandKey + "/rg-logo.svg"
                        ),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "header-txt" }, [
                      _vm._v(_vm._s(_vm.$t("Header.InfoMessageTwo")))
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.mobileBigAndBelow &&
          (_vm.brandKey === "sb" ||
            _vm.brandKey === "mav" ||
            _vm.brandKey === "qcasino")
            ? _c(
                "div",
                {
                  staticClass: "rg",
                  class: [
                    {
                      postLoginAlertExist:
                        _vm.postLoginAlertExist && !_vm.mobileBigAndBelow
                    },
                    _vm.state
                  ]
                },
                [
                  _c("div", { staticClass: "rg-holder" }, [
                    _vm.brandKey === "sb" && _vm.state === "MD"
                      ? _c("span", {
                          staticClass: "header-txt",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("Header.InfoMessageOne.MD")
                            )
                          }
                        })
                      : _c("span", { staticClass: "header-txt" }, [
                          _vm._v(
                            _vm._s(_vm.$t("Header.InfoMessageOne." + _vm.state))
                          )
                        ]),
                    _vm._v(" "),
                    _vm.brandKey === "sb" && _vm.state === "NJ"
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.go2ResponsibleGaming.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "rg-logo nj",
                              attrs: {
                                src: _vm.mediaServer(
                                  "/static/brand-img/" +
                                    _vm.brandKey +
                                    "/rg-logo-nj.svg"
                                ),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "header-txt" }, [
                              _vm._v(_vm._s(_vm.$t("Header.InfoMessageTwo")))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.brandKey === "sb" && _vm.state !== "NJ"
                      ? _c(
                          "a",
                          { attrs: { href: _vm.$t("RGLink." + _vm.state) } },
                          [
                            _c("img", {
                              staticClass: "rg-logo",
                              attrs: {
                                src: _vm.mediaServer(
                                  "/static/brand-img/" +
                                    _vm.brandKey +
                                    "/rg-logo.svg"
                                ),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "header-txt" }, [
                              _vm._v(_vm._s(_vm.$t("Header.InfoMessageTwo")))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.brandKey === "qcasino" || _vm.brandKey === "mav"
                      ? _c(
                          "a",
                          { attrs: { href: _vm.$t("RGLink." + _vm.state) } },
                          [
                            _c("img", {
                              staticClass: "rg-logo",
                              attrs: {
                                src: _vm.mediaServer(
                                  "/static/brand-img/" +
                                    _vm.brandKey +
                                    "/rg-logo.svg"
                                ),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "header-txt" }, [
                              _vm._v(_vm._s(_vm.$t("Header.InfoMessageTwo")))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.brandKey === "sb" && _vm.state == "NJ"
                    ? _c("header-info")
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isNotOpenedFromIFrame && _vm.brandLayout === "generic"
            ? _c(
                "div",
                { staticClass: "logo-holder" },
                [
                  ((this.$route.name === "sports" ||
                    ["pm", "racing"].includes(_vm.currentNavGroupKey)) &&
                    _vm.mobileBigAndBelow) ||
                  (this.$route.name === "account-joinUs" &&
                    _vm.brandTemplate === "generic_2" &&
                    _vm.mobileBigAndBelow) ||
                  !_vm.mobileBigAndBelow
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "logo",
                          on: {
                            click: function($event) {
                              return _vm.clickOnLogoHandler()
                            }
                          }
                        },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "sports" } } },
                            [
                              _c("img", {
                                staticClass: "logo-holder-image",
                                attrs: {
                                  src: _vm.mediaServer(
                                    "/static/brand-img/" +
                                      _vm.brandKey +
                                      "/logo-white.png"
                                  ),
                                  alt: _vm.brandKey
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isNotOpenedFromIFrame && _vm.brandLayout !== "generic"
            ? _c(
                "div",
                { staticClass: "logo-holder" },
                [
                  _vm.mobileBigAndBelow &&
                  (this.$route.name === "sports" ||
                    _vm.brandKey === "sb" ||
                    _vm.brandKey === "mav")
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "logo",
                          on: {
                            click: function($event) {
                              return _vm.clickOnLogoHandler()
                            }
                          }
                        },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "sports" } } },
                            [
                              _c("img", {
                                staticClass: "logo-holder-image",
                                attrs: {
                                  src: _vm.mediaServer(
                                    "/static/brand-img/" +
                                      _vm.brandKey +
                                      "/logo-white.png"
                                  ),
                                  alt: _vm.brandKey
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : !_vm.mobileBigAndBelow
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "logo",
                          on: {
                            click: function($event) {
                              return _vm.clickOnLogoHandler()
                            }
                          }
                        },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "sports" } } },
                            [
                              !_vm.mobileBigAndBelow
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.mediaServer(
                                        "/static/brand-img/" +
                                          _vm.brandKey +
                                          "/logo-white.png"
                                      ),
                                      alt: _vm.brandKey
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm.mobileBigAndBelow &&
                      ["pm", "racing"].includes(_vm.currentNavGroupKey)
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "logo",
                          on: {
                            click: function($event) {
                              return _vm.clickOnLogoHandler()
                            }
                          }
                        },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "sports" } } },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.mediaServer(
                                    "/static/brand-img/" +
                                      _vm.brandKey +
                                      "/logo-white.png"
                                  ),
                                  alt: _vm.brandKey
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileBigAndBelow &&
          this.$route.name !== "sports" &&
          !["pm", "racing"].includes(_vm.currentNavGroupKey)
            ? [
                _c("div", { staticClass: "back-btn-wrapper" }, [
                  _c("span", { staticClass: "header-back-btn" }, [
                    _c("div", { staticClass: "buttons" }, [
                      _c(
                        "span",
                        {
                          staticClass: "btn btn--icon theme--dark",
                          on: {
                            click: function($event) {
                              return _vm.goBack()
                            }
                          }
                        },
                        [
                          _vm.brandKey === "sb"
                            ? _c(
                                "i",
                                {
                                  staticClass: "icon material-icons",
                                  attrs: { "aria-hidden": "true" }
                                },
                                [_vm._v("navigate_before")]
                              )
                            : _c(
                                "i",
                                {
                                  staticClass: "icon material-icons",
                                  attrs: { "aria-hidden": "true" }
                                },
                                [_vm._v("arrow_back")]
                              )
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.showPageTitleInHeader && _vm.brandLayout === "generic"
                  ? _c("sports-breadcrumb", { attrs: { inHeader: true } })
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.mobileBigAndBelow
            ? _c(
                "v-flex",
                {
                  staticClass: "menu",
                  attrs: { sm12: "", "align-content-end": "" }
                },
                [_c("main-navigation")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isReadOnly
            ? _c(
                "v-flex",
                { staticClass: "account-widget" },
                [_c("account-info-widget-component")],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.isOpenedFromWebView &&
      _vm.mobileGeolocationInProgress.display &&
      _vm.isLoggedIn
        ? _c("mobile-geolocation-dialog")
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileBigAndBelow
        ? _c("headlinesLight", { attrs: { category: "PostLoginAlert" } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "headline-dialog", fullscreen: false },
          model: {
            value: _vm.headlineDialog,
            callback: function($$v) {
              _vm.headlineDialog = $$v
            },
            expression: "headlineDialog"
          }
        },
        [_c("headline-overlay")],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "add-selection-dialog",
            transition: "dialog-bottom-transition",
            persistent: "",
            fullscreen: false
          },
          model: {
            value: _vm.addingSelectionDialog,
            callback: function($$v) {
              _vm.addingSelectionDialog = $$v
            },
            expression: "addingSelectionDialog"
          }
        },
        [_c("adding-selections-dialog")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df067998", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df067998","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/HeaderPart.vue
// module id = null
// module chunks = 